import Roles from '../Roles'

const FALLBACK_ROUTE = '/dashboard'

// Route meta flag -> check the user's role must pass to open the route.
const ROLE_REQUIREMENTS = {
  publisherOnly: Roles.isPublisher,
  adOpsOnly: Roles.isAdOps
}

/**
 * Resolves where to send the user when the target route requires a role
 * they do not have. Returns null when the route is open to them.
 * The role is only fetched for routes that declare a requirement, and a
 * failed lookup is treated as a missing role.
 */
export async function roleGuard(to, getRole) {
  const checks = Object.keys(ROLE_REQUIREMENTS)
    .filter(flag => to.meta?.[flag])
    .map(flag => ROLE_REQUIREMENTS[flag])

  if (checks.length === 0) {
    return null
  }

  try {
    const role = await getRole()
    return checks.every(check => check(role)) ? null : FALLBACK_ROUTE
  } catch (e) {
    return FALLBACK_ROUTE
  }
}
